




















































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import { PropOptions } from "vue";
import Miembro from "../../models/miembro/miembro.model";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import SolicitudActualizacionBeneficiarioModel from "@/models/tramite/solicitud-actulizacion/beneficiario.model";
import PersonaDireccion from "@/models/persona/personaDireccion.model";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import Hogar from "@/models/hogar/hogar.model";
import Direccion from "@/models/direccion.model";
import Persona from "@/models/persona/persona.model";
import Beneficiario from "@/models/beneficiario/beneficiario.model";
import SolicitudCambioComposicionFamiliar, {
  SolicitudCambioComposicionFamiliarInclusion,
  SolicitudCambioComposicionFamiliarExclusion,
  SolicitudCambioComposicionFamiliarCorreccion,
  SolicitudCambioComposicionFamiliarDocumento
} from "@/models/tramite/solicitud-cambio-composicion-familiar";
import { Utils } from "@/core/Utils";
import NameValue from "@/models/nameValue.model";
import TipoTramite from "@/models/tipoTramite";
import DatePickerComponent from "@/components/base-datePicker/base-date-picker.vue";
@Component({
  components: {
    DatePickerComponent
  }
})
export default class SolicitudActualizacionBeneficiario extends BaseVue {
  @Prop() readonly solicitante!: Persona;
  @Prop() readonly beneficiario!: Beneficiario;
  @Prop() readonly tipoTramite!: TipoTramite;
  @Prop() readonly content!: TramiteBeneficiario;
  @Prop() readonly codigoTramiteCorreccion!: string;
  @Prop() readonly codigoDocAdicionalesCorreccion!: string;
  @Prop() readonly codigoTramiteInclusion!: string;
  @Prop() readonly codigoDocAdicionalesInclusion!: string;
  @Prop() readonly codigoTramiteExclusion!: string;
  @Prop() readonly codigoDocAdicionalesExclusion!: string;

  model = new SolicitudActualizacionBeneficiarioModel();
  tableData: Miembro[] = [];
  tipoCorreccion = new TipoTramite();
  nameValueCorreccion = new NameValue();
  tipoInclusion = new TipoTramite();
  nameValueInclusion = new NameValue();
  tipoExclusion = new TipoTramite();
  nameValueExclusion = new NameValue();

  get personaId() {
    if (this.beneficiario && this.beneficiario.personaId)
      return this.beneficiario.personaId;
    if (this.solicitante && this.solicitante.id) return this.solicitante.id;
    return 0;
  }

  created() {
    let props = [];
    props.push(
      new TipoTramiteComponentProp(
        "codigoTramiteCorreccion",
        "string",
        true,
        "Código solicitud de correción"
      ),
      new TipoTramiteComponentProp(
        "codigoDocAdicionalesCorreccion",
        "string",
        true,
        "Código de docs. correción"
      ),
      new TipoTramiteComponentProp(
        "codigoTramiteInclusion",
        "string",
        true,
        "Código solicitud de inclusión"
      ),
      new TipoTramiteComponentProp(
        "codigoDocAdicionalesInclusion",
        "string",
        true,
        "Código de docs. inclusión"
      ),
      new TipoTramiteComponentProp(
        "codigoTramiteExclusion",
        "string",
        true,
        "Código solicitud de exclusión"
      ),
      new TipoTramiteComponentProp(
        "codigoDocAdicionalesExclusion",
        "string",
        true,
        "Código de docs. exclusión"
      )
    );
    this.$emit("render", props);
  }
  destroyed() {
    if (this.content) {
      let contenido = this.content as any;
      if (contenido && contenido.actualizacionPerfil)
        delete contenido.actualizacionPerfil;
      this.$emit("update:content", contenido);
    }
  }
  get hogarCode() {
    if (this.beneficiario && this.beneficiario.codigoHogar)
      return this.beneficiario.codigoHogar;
    return "";
  }
  get hogarId() {
    if (this.beneficiario && this.beneficiario.hogarId)
      return this.beneficiario.hogarId;
    return 0;
  }

  //Cambio composicion
  onChangeGeneraCambioComposicionFamiliar(val: boolean) {
    this.model.solicitudCambioComposicionFamiliar = val
      ? new SolicitudCambioComposicionFamiliar(this.hogarId)
      : undefined;
  }
  miembroTableConfig!: BTableConfig<Miembro>;
  onLoadMiembroTable(config: BTableConfig<Miembro>) {
    config.data.forEach(d => this.tableData.push(d));
    this.miembroTableConfig = config;
  }
  get miembrosCambioComposicion() {
    let miembros: any[] = [];
    this.incluidos.forEach(m => miembros.push(m));
    this.excluidos.forEach(m => miembros.push(m));
    this.corrigiendo.forEach(m => miembros.push(m));
    return miembros;
  }
  removeMiembro(
    index: number,
    miembro: Miembro,
    inclusion = false,
    exclusion = false,
    correccion = false
  ) {
    if (inclusion) {
      this.incluidos.splice(index, 1);
      // this.setIncluidos(this.incluidos);
    }

    if (exclusion) {
      this.excluidos.splice(index, 1);
      // this.setExcluidos(this.excluidos);
    }

    if (correccion) {
      this.corrigiendo.splice(index, 1);
      // this.setCorregidos(this.corrigiendo);
    }
  }
  //Inclusion
  addingMiembro = false;
  repoPersona = new BaseRepository<Persona>("Personas");
  get incluidos() {
    if (this.model.solicitudCambioComposicionFamiliar)
      return this.model.solicitudCambioComposicionFamiliar.miembrosIncluidos;
    return [];
  }
  async incluirMiembro(miembro: Miembro) {
    if (this.incluidos.some(x => x.personaId === miembro.personaId)) {
      this.operationNoAllowed(
        "La persona ya es parte de los miembros incluídos"
      );
      return;
    }
     if (!miembro.personaId && miembro.persona) {
      this.addingMiembro = true;
      let p = await this.repoPersona.create(miembro.persona);
      miembro.personaId = p.id;
      miembro.persona = p;
      this.addingMiembro = false;
    }

    let val = new SolicitudCambioComposicionFamiliarInclusion(
      this.hogarId,
      miembro.parentescoId
    );
    val.codHogar = miembro.codigoHogar;
    val.razonInclusionId = miembro.razonInclusionId;
    val.razonInclusionOtro = miembro.razonInclusionOtro;
    val.personaId = miembro.personaId;
    val.persona = miembro.persona;
    val.parentescoNombre = miembro.parentescoNombre;
    this.incluidos.push(val);
    //this.setIncluidos(this.incluidos);
  }
  //End inclusion

  //Exclusion
  get excluidos() {
    if (this.model.solicitudCambioComposicionFamiliar)
      return this.model.solicitudCambioComposicionFamiliar.miembrosExcluidos;
    return [];
  }
  setExcluidos(list: Miembro[], current: Miembro) {
    if (this.model.solicitudCambioComposicionFamiliar) {
      if (!list.length)
        this.model.solicitudCambioComposicionFamiliar.miembrosExcluidos = [];
    }

    if (current) {
      var exite = list.find(x => x.personaId === current.personaId);
      if (!exite) {
        var ind = this.excluidos.findIndex(
          x => x.personaId === current.personaId
        );
        if (ind >= 0) this.excluidos.splice(ind, 1);
      }
    }
    list.forEach(m => {
      let member = this.excluidos.find(x => x.personaId === m.personaId);
      if (!member) {
        if (this.miembroTableConfig.checking.isCheckableRow(m as any)) {
          let val = new SolicitudCambioComposicionFamiliarExclusion(
            this.hogarId,
            m.id,
            m.personaId
          );
          val.codHogar = m.codigoHogar;
          val.persona = m.persona;
          val.parentescoNombre = m.parentescoNombre;
          val.cedulaQuienPoseeMenor = m.cedulaQuienPoseeMenor;
          val.parentescoQuienPoseeMenorId = m.parentescoQuienPoseeMenorId;
          val.razonExclusionId = m.razonExclusionId;
          val.razonMuerte = m.razonMuerte;
          val.fechaFallecimiento = m.fechaFallecimiento;
          this.excluidos.push(val);
        }
      }
    });
  }
  //End exclusion

  //Correccion
  get corrigiendo() {
    if (this.model.solicitudCambioComposicionFamiliar)
      return this.model.solicitudCambioComposicionFamiliar.miembrosCorregidos;
    return [];
  }
  isEditing = false;
  editingMiembro: Miembro | undefined | null = null;
  editingMiembroModel: Miembro | undefined | null = null;
  editingMiembroToSave: Miembro | null = null;
  getMember(m: any) {
    let val = new SolicitudCambioComposicionFamiliarCorreccion(
      this.hogarId,
      m.id,
      m.personaId
    );
    if (m.persona) {
      let ignore = [
        "id",
        "deleted",
        "createdDate",
        "updatedDate",
        "createdBy",
        "updatedBy",
        "cedula",
        "fechaNacimiento"
      ];
      Utils.mapToObject(m.persona, val, { ignore: ignore });
      if (m.persona.cedula) val.cedula = m.persona.cedula.replace(/-/g, "");
      else val.cedula = undefined;
      if (m.persona.fechaNacimiento)
        val.fechaNacimiento = new Date(m.persona.fechaNacimiento.toString());
    }
    val.codHogar = m.codigoHogar;
    val.parentescoId = m.parentescoId;
    val.parentescoNombre = m.parentescoNombre;
    val.persona = m.persona;
    val.documentos = m.documentos;
    val.miembroId = m.id || m.miembroId;
    return val;
  }
  mapModel(obj: any) {
    let m = this.map<Miembro>(obj);
    let p = m.persona as Persona;
    (m.persona as Persona).nombreCompleto = `${p.nombre1} ${p.nombre2} ${p.apellido1} ${p.apellido2}`;
    return m;
  }
  editModelChange(value: Miembro) {
    this.editingMiembroToSave = value;
  }
  corregirMiembro(id: number, miembro: Miembro) {
    if (this.corrigiendo.some(x => x.miembroId === id)) return;
    let m = this.mapModel(miembro);
    this.corrigiendo.push(this.getMember(m));
    //  this.miembroTableConfig.actions.isEditableRow = (row: Miembro) =>
    //     !this.corrigiendo.some(m => m.personaId === row.personaId);
  }
  async onSaveEdit() {
    let ref = this.$refs.miembro_edit as any;
    if (ref) {
      let isValid = await ref.isValid();
      if (!isValid) return;
    }
    let index = this.corrigiendo.findIndex(
      (x: any) =>
        x.personaId === (this.editingMiembroToSave as Miembro).personaId
    );
    let m = this.mapModel(this.editingMiembroToSave);
    this.corrigiendo.splice(index, 1, this.getMember(m));
    this.isEditing = false;
    // this.miembroTableConfig.actions.isEditableRow = (row: Miembro) =>
    //   !this.model.miembrosCorregidos.some(m => m.personaId === row.personaId);
  }
  showModalEditMiembro(id: number, row: Miembro) {
    this.editingMiembroModel = this.mapModel(row);
    this.editingMiembro = this.mapModel(row);
    this.isEditing = true;
  }
  restartEdit() {
    this.editingMiembro = this.mapModel(this.editingMiembroModel);
  }
  closeEdit() {
    this.isEditing = false;
    this.editingMiembro = null;
    this.editingMiembroModel = null;
    this.editingMiembroToSave = null;
  }
  //End Correccion
  //End cambio composicion familiar

  @Watch("model", { deep: true })
  set(model: SolicitudActualizacionBeneficiarioModel) {
    if (this.content) {
      let contenido = this.content as any;
      contenido.actualizacionPerfil = this.map<
        SolicitudActualizacionBeneficiarioModel
      >(model);
      contenido.actualizacionPerfil.tipoTramiteId = this.tipoTramite.id;
      contenido.actualizacionPerfil.tituloTipoTramite = this.tipoTramite.nombre;
      contenido.actualizacionPerfil.codigoTipoTramite = this.tipoTramite.codigo;

      if (model.generaCambioComposicionFamiliar) {
        if (model.solicitudCambioComposicionFamiliar) {
          contenido.actualizacionPerfil.solicitudCambioComposicionFamiliar.inclusion =
            this.incluidos.length > 0;

          contenido.actualizacionPerfil.solicitudCambioComposicionFamiliar.exclusion =
            this.excluidos.length > 0;

          contenido.actualizacionPerfil.solicitudCambioComposicionFamiliar.correccion =
            this.corrigiendo.length > 0;
        }
      } else {
        contenido.actualizacionPerfil.solicitudCambioComposicionFamiliar = null;
      }

      if (!model.generaCambioDireccion)
        contenido.actualizacionPerfil.tramiteCambioDireccion = null;

      this.$emit("update:content", contenido);
      if (this.miembroTableConfig) {
        this.miembroTableConfig.checking.isCheckableRow = (row: Miembro) =>
          !this.corrigiendo.some(m => m.personaId === row.personaId);
        this.miembroTableConfig.actions.isEditableRow = (row: Miembro) =>
          !this.miembrosCambioComposicion.some(
            m => m.personaId === row.personaId
          );
      }
    }
  }
  onChangeInclusionDocs(
    miembro: SolicitudCambioComposicionFamiliarInclusion,
    tipos: any,
    docs: any[]
  ) {
    miembro.documentos = docs.map(x => {
      let doc = new SolicitudCambioComposicionFamiliarDocumento();
      doc.personaId = miembro.personaId;
      doc.documentoId = x.documentoId;
      doc.documento = x.documento;
      doc.tipoDocumentoId = x.tipoDocumentoId;
      doc.tipoDocumentoNombre = x.tipoDocumentoNombre;
      return doc;
    });
  }
  onChangeExclusionDocs(
    miembro: SolicitudCambioComposicionFamiliarExclusion,
    tipos: any,
    docs: any[]
  ) {
    miembro.documentos = docs.map(x => {
      let doc = new SolicitudCambioComposicionFamiliarDocumento();
      doc.personaId = miembro.personaId;
      doc.documentoId = x.documentoId;
      doc.documento = x.documento;
      doc.tipoDocumentoId = x.tipoDocumentoId;
      doc.tipoDocumentoNombre = x.tipoDocumentoNombre;
      return doc;
    });
  }
  onChangeCorreccionDocs(
    miembro: SolicitudCambioComposicionFamiliarCorreccion,
    tipos: any,
    docs: any[]
  ) {
    miembro.documentos = docs.map(x => {
      let doc = new SolicitudCambioComposicionFamiliarDocumento();
      doc.personaId = miembro.personaId;
      doc.documentoId = x.documentoId;
      doc.documento = x.documento;
      doc.tipoDocumentoId = x.tipoDocumentoId;
      doc.tipoDocumentoNombre = x.tipoDocumentoNombre;
      return doc;
    });
  }
  hogar = new Hogar();
  repoHogar = new BaseRepository<Hogar>("hogar");
  @Watch("beneficiario", { immediate: true, deep: true })
  async onBeneficiarioChange(value: Beneficiario) {
    if (value && value.id) {
      this.hogar =
        (await this.repoHogar.one(`id=${value.hogarId}`)) || new Hogar();
    }
  }
  @Watch("codigoDocAdicionalesCorreccion", { immediate: true })
  async onCodigoDocAdicionalesCChange(value: string) {
    if (value) {
      this.tipoCorreccion = await new BaseRepository<TipoTramite>(
        "tipoTramite"
      ).one(`codigo="${this.codigoTramiteCorreccion}"`);
      this.nameValueCorreccion = await new BaseRepository<NameValue>(
        "namevalues"
      ).one(`codigo="${value}"`);
    }
  }
  @Watch("codigoDocAdicionalesInclusion", { immediate: true })
  async onCodigoDocAdicionalesIChange(value: string) {
    if (value) {
      this.tipoInclusion = await new BaseRepository<TipoTramite>(
        "tipoTramite"
      ).one(`codigo="${this.codigoTramiteInclusion}"`);
      this.nameValueInclusion = await new BaseRepository<NameValue>(
        "namevalues"
      ).one(`codigo="${value}"`);
    }
  }
  @Watch("codigoDocAdicionalesExclusion", { immediate: true })
  async onCodigoDocAdicionalesEChange(value: string) {
    if (value) {
      this.tipoExclusion = await new BaseRepository<TipoTramite>(
        "tipoTramite"
      ).one(`codigo="${this.codigoTramiteExclusion}"`);
      this.nameValueExclusion = await new BaseRepository<NameValue>(
        "namevalues"
      ).one(`codigo="${value}"`);
    }
  }

  public async isValid() {
    let isValid = await this.validateCurrentValidator();
    if (!isValid) return false;

    return this.validateRefCollection("documentos");
  }
}
